import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import SoyRxGrid from './SoyRxGrid';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import SoyRxMap from './SoyRxMap';
import { actions } from '../../store/dux/soyrx-dux';
import { Section } from '../Section';

export default function SoyRXPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.loadLayerMeta());
  }, [dispatch]);

  return (
    <Section>
      <ResizablePanel topPanel={<SoyRxMap />} bottomPanel={<SoyRxGrid />} />
    </Section>
  );
}
